<template>
  <base-overlay :show="uploading">
    <div
      class="upload-item-image__wrapper"
      @click="clickHandler"
    >
      <input
        ref="inputRef"
        type="file"
        style="display:none"
        @change="changeHandler"
      >
      <img
        v-if="imageUrl"
        style="max-width: 100%;max-height: 100%; min-height: 100%; min-width: 100%;"
        :src="imageUrl"
      >
      <template v-else>
        <feather-icon
          icon="ImageIcon"
          size="40"
        />
        <span>Browse Files</span>
      </template>
    </div>
  </base-overlay>
</template>

<script>
import axios from 'axios'
import { ref, watch } from '@vue/composition-api'
import axiosIns from '@/libs/axios'
import { errorNotification, successNotification } from '@/utils/toast-notifications'
import BaseOverlay from '@/UI/BaseOverlay.vue'

export default {
  components: {
    BaseOverlay,
  },
  props: {
    itemImageUrl: {
      type: String,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const imageUrl = ref()
    watch(() => props.itemImageUrl, newVal => {
      if (newVal) {
        imageUrl.value = props.itemImageUrl
      }
    })
    const uploadedFile = ref()
    const uploading = ref(false)
    const businessId = ctx.root.$route.params.id

    const clickHandler = () => {
      ctx.refs.inputRef.click()
    }

    // eslint-disable-next-line no-async-promise-executor
    const uploadItemImage = async file => new Promise(async (resolve, reject) => {
      try {
        const preSignedResponse = await axiosIns.get(
          `/businesses/${businessId}/item/image-presigned-url`,
        )
        const { key, url } = preSignedResponse.data.data
        await axios.put(url, file, {
          headers: { 'Content-Type': file.type },
        })
        resolve(key)
      } catch (err) {
        reject(err)
      }
    })
    const uploadImage = async () => {
      try {
        uploading.value = true
        const key = await uploadItemImage(uploadedFile.value)

        ctx.emit('image-uploaded', key)
        successNotification('Image uploaded successfully')
      } catch (error) {
        errorNotification('Couldn`t upload photo, try again')
        ctx.emit('image-deleted')
      } finally {
        uploading.value = false
      }
    }
    const changeHandler = event => {
      // @ts-ignore
      const { files } = event.target
      if (files && files.length) {
        const fileName = files[0].name
        if (
          !fileName.endsWith('.jpg')
          && !fileName.endsWith('.jpeg')
          && !fileName.endsWith('.png')
          && !fileName.endsWith('.gif')
        ) {
          errorNotification('Only images allowed')
          return
        }
        // eslint-disable-next-line prefer-destructuring
        uploadedFile.value = files[0]
        imageUrl.value = URL.createObjectURL(files[0])
        // eslint-disable-next-line no-param-reassign
        event.target.value = ''
        uploadImage()
      }
    }
    return {
      clickHandler,
      uploading,
      uploadImage,
      changeHandler,
      imageUrl,
    }
  },
}
</script>

<style scoped>
.upload-item-image__wrapper {
  height: 11rem;
  border-radius: 15px;
  background: rgb(228 226 230);
  margin: 10px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
}
</style>
